<template>
  <PageTemplate>

    <Loader v-if="!isLoaded"/>
    <div v-else>
      <div class="d-flex justify-content-between">
        <h6 class="element-header">
          Anfrage
        </h6>

        <CreateButton
            :label="$t('general.button.back')"
            :to="{ name: 'privateCoachingInquiryOverviewListForCoach' }">
        </CreateButton>
      </div>

      <div class="element-box">
        <h5 class="form-header mb-4">Einzelcoaching Anfragedetails</h5>

        <div class="row m-0 mb-4 portal_user_data">
          <div class="col-12">
            <h5 class="pb-2">Kundendetails</h5>
          </div>
          <div class="col-lg-3 col-md-6 col-sm-12 mb-md-2 mb-sm-2">
            <p style="font-size: 16px; margin-bottom: 10px"><span class="pe-1">Vorname: </span>
              {{ coachingData?.unemployed?.firstName }}
            </p>
            <p style="font-size: 16px; margin-bottom: 10px"><span class="pe-1">Standort: </span>
              {{ coachingData?.unemployed?.location?.name }}
            </p>
            <p style="font-size: 16px; margin-bottom: 10px"><span class="pe-1">JC / AA Nummer: </span>
              {{ coachingData?.unemployed?.aaNumber }}
            </p>
          </div>

          <div class="col-lg-3 col-md-6 col-sm-12 mb-md-2 mb-sm-2">
            <p style="font-size: 16px; margin-bottom: 10px">
              <span class="pe-1">Nachname: </span>
              {{ coachingData?.unemployed?.lastName }}
            </p>
            <p style="font-size: 16px; margin-bottom: 10px">
              <span class="pe-1">Telefonnummer: </span>
              {{ coachingData?.unemployed?.phone }}
            </p>
            <p style="font-size: 16px; margin-bottom: 10px">
              <span class="pe-1">Ort: </span>
              {{ coachingData?.unemployed?.city }}
            </p>
          </div>

          <div class="col-lg-3 col-md-6 col-sm-12 mb-md-2 mb-sm-2">
            <p style="font-size: 16px; margin-bottom: 10px">
              <span class="pe-1">Straße:  </span>
              {{ icoachingData?.unemployed?.address }}
            </p>
            <p style="font-size: 16px; margin-bottom: 10px">
              <span class="pe-1">PLZ:  </span>
              {{ coachingData?.unemployed?.zip }}
            </p>
            <p style="font-size: 16px; margin-bottom: 10px">
              <span class="pe-1">Geburtsdatum:  </span>
              {{ coachingData?.unemployed?.birthdate }}
            </p>
          </div>

          <div class="clearfix"></div>
          <div
              style="width: 100%; border: 1px solid rgba(137, 148, 153, 0.3); margin-top: 8px; margin-bottom: 20px;"></div>

          <div class="col-12">
            <h5 class="pb-2">Maßnahmedetails</h5>
          </div>

          <div class="col-lg-3 col-md-6 col-sm-12 mb-md-2 mb-sm-2">
            <p style="font-size: 16px; margin-bottom: 10px"><span class="pe-1">Maßnahmenart: </span>
              {{ coachingData?.nameOfCoaching?.operationTypeTranslated }}
            </p>
            <p style="font-size: 16px; margin-bottom: 5px">Trainer:</p>
            <p v-for="(coach, index) in coachingData.coaches"
               :key="index"
               style="margin-bottom: 3px;">
              - {{ coach.firstName }} {{ coach.lastName }}
            </p>
          </div>
          <div class="col-lg-3 col-md-6 col-sm-12 mb-md-2 mb-sm-2">
            <p style="font-size: 16px; margin-bottom: 10px">
              <span class="pe-1">Start: </span>
              {{ coachingData.startDate }}
              &nbsp;
              <span class="pe-1">End: </span>
              {{ coachingData.endDate }}
            </p>
          </div>
          <div class="col-lg-3 col-md-6 col-sm-12 mb-md-2 mb-sm-2">
            <p style="font-size: 16px; margin-bottom: 10px">
              <span class="pe-1">Stand:  </span>
              {{ coachingData.unitsDone }}
            </p>
          </div>
        </div>

        <div>
          <form @submit.prevent="accept" novalidate v-if="coachingData.status === 'in_allocation'">
            <div class="row">
              <div class="col-lg-3 col-md-6 col-sm-12">
                <SelectVue
                    v-model="formData.coachId"
                    :options="coachDropdown"
                    :label="'Trainer auswählen und Anfrage annehmen'"
                    :is-clear="true"
                    :validation="v$.coachId"
                    :messages="v$.coachId.required.$message"
                    :placeholder="$t('general.employee')"/>
              </div>
              <div class="col-lg-2 col-sm-12 col-12" style="margin-top: 25px;">
                <button type="submit" class="btn btn-primary custom_search_button2">
                  Akzeptieren
                </button>
              </div>
            </div>
          </form>

          <h6 v-else>Status: <span style="color:green">{{ coachingData.statusTranslated }}</span></h6>
        </div>


      </div>
    </div>

    <ModalConfirm
        v-model="showAcceptModal"
        :confirmationQuestion="t('general.approve_question')"
        header=""
        :onConfirm="approveTravelExpenses"/>
  </PageTemplate>
</template>


<script setup>
import dropdownService from '@/api/Dropdown';
import privateCoachingService from '@/api/Unemployed/PrivateCoaching';
import CreateButton from '@/components/CreateButton.vue';
import Loader from '@/components/Loader.vue';
import ModalConfirm from '@/components/modal/ModalConfirm.vue';
import PageTemplate from '@/components/PageTemplate.vue';
import SelectVue from '@/components/SelectVue.vue';
import { CloseToast, ErrorToast, SuccessToast } from '@/components/VueToast';
import router from '@/router';
import { requiredRule } from '@/shared/validators/validationRules';
import useVuelidate from '@vuelidate/core';
import { computed, onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';

const { t }         = useI18n();
const route         = useRoute();
const coachingId    = route.params.id;
const coachingData  = ref([]);
const isSearching   = ref(false);
const isLoaded      = ref(false);
const coachDropdown = ref([]);
const isSubmitting  = ref(false);

const formData = ref({
  coachId: null,
});

const rules = computed(() => {
  return {
    coachId: requiredRule(t),
  };
});

const v$ = useVuelidate(rules, formData);

async function getPrivateCoachingData() {
  try {
    const { data }     = await privateCoachingService.getPrivateCoaching(coachingId);
    coachingData.value = data.data;

    const { data: dropdownData } = await dropdownService.getCoachesForInquiryAccept(coachingId);
    coachDropdown.value          = dropdownData.data.map(item => ({
      label: `${item.fullName}`,
      value: item.id,
    }));
  } catch (error) {
    await ErrorToast(error);
    isSearching.value = false;
  }
}

async function accept() {
  v$.value.$touch();
  if (v$.value.$invalid) {
    return;
  }

  try {
    isSubmitting.value = false;
    await privateCoachingService.acceptInquiry(coachingId, formData.value.coachId);
    await router.push({ name: 'privateCoachingInquiryOverviewListForCoach' });
    SuccessToast(t('general.toasts.save_success'));
  } catch (error) {
    await ErrorToast(error);
  }
}

onMounted(async () => {
  CloseToast();
  await getPrivateCoachingData();

  isLoaded.value = true;
});

</script>

<style scoped>

</style>